






































































































































































import { Component, Vue } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { CustodianDrivewealthListRequest, UpdateCustodianDefaultAgreementRequest } from "@/admin/types";
import { AgreementCategory, DrivewealthAccountManagementType, UserPermission } from "@/shared/types";
import { useInstrumentListStore } from "@/admin/store/instrumentList";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useNotifierStore } from "@/shared/store/notifier";

@Component
export default class InstrumentAssignment extends Vue {
  $validator: Validator;

  instrumentListStore = useInstrumentListStore();
  rolePermissionsStore = useRolePermissionsStore();
  signingDocumentStore = useSigningDocumentStore();
  notifierStore = useNotifierStore();

  isLoaded = false;
  isSubmitting = false;
  custodian = 0;
  submitSdbaDisabled = false;
  submitCuratedDisabled = false;
  curatedDefaultInstrumentListId = 0;
  sdbaDefaultInstrumentListId = 0;
  managedAgreementListId = "0";
  advisoryAgreementListId = "0";
  openBrokerageAgreementListId = "0";
  submitManagedDisabled = false;
  submitAdvisoryDisabled = false;
  submitOpenBrokerageDisabled = false;

  custodians = [
    { value: 0, text: "Select Custodian"},
    { value: 5, text: "Allegacy" },
    { value: 4, text: "Avidia" },
    { value: 2, text: "Elements" },
    { value: 6, text: "HsaBank" },
  ];

  defaultAgreements = [];

  created () {
    this.instrumentListStore.loadInstrumentLists();
    this.signingDocumentStore.loadAllAdmin();
  }

  loadCustodianDefaultList () {
    this.instrumentListStore.loadCustodianDefaultInstrumentList(Number(this.custodian))
        .then(() => {
          if (this.instrumentListStore.advisoryCustodianDefaultInstrumentList) {
            this.curatedDefaultInstrumentListId = this.instrumentListStore.advisoryCustodianDefaultInstrumentList.listId;
          } else {
            this.curatedDefaultInstrumentListId = this.instrumentListStore.advisoryCustodianDefaultInstrumentList ?
              this.instrumentListStore.advisoryCustodianDefaultInstrumentList.listId : 1;
          }

          if (this.instrumentListStore.openBrokerageCustodianDefaultInstrumentList) {
            this.sdbaDefaultInstrumentListId = this.instrumentListStore.openBrokerageCustodianDefaultInstrumentList.listId;
          } else {
            this.sdbaDefaultInstrumentListId = this.instrumentListStore.openBrokerageCustodianDefaultInstrumentList ?
              this.instrumentListStore.openBrokerageCustodianDefaultInstrumentList.listId : 2;
          }
        })
        .finally(() => { this.isLoaded = true; });

    this.signingDocumentStore.getCustodianDefaultAgreement(Number(this.custodian))
        .then(() => {
          const agreements = this.signingDocumentStore.custodianDefaultAgreements;
          if (agreements.length !== 0) {
            const managedAgreement = agreements.filter(x => x.accountType === DrivewealthAccountManagementType.RiaManaged);
            this.managedAgreementListId = managedAgreement.length !== 0 ? managedAgreement[0].documentKey : "0";

            const advisoryAgreement = agreements.filter(x => x.accountType === DrivewealthAccountManagementType.Advisory);
            this.advisoryAgreementListId = advisoryAgreement.length !== 0 ? advisoryAgreement[0].documentKey : "0";

            const openBrokerageAgreement = agreements.filter(x => x.accountType === DrivewealthAccountManagementType.OpenBrokerage);
            this.openBrokerageAgreementListId = openBrokerageAgreement.length !== 0 ? openBrokerageAgreement[0].documentKey : "0";
          } else {
            this.managedAgreementListId = "0";
            this.advisoryAgreementListId = "0";
            this.openBrokerageAgreementListId = "0";
          }
        });
  }

  onCustodianChanged () {
    if (this.custodian !== 0) {
      this.loadCustodianDefaultList();
    }
  }

  saveCuratedList () {
    if (this.submitCuratedDisabled) {
      return;
    }

    this.submitCuratedDisabled = true;

    const request: CustodianDrivewealthListRequest = {
      custodian: Number(this.custodian),
      instrumentListId: this.curatedDefaultInstrumentListId,
      investmentOption: DrivewealthAccountManagementType.Advisory
    };
    this.instrumentListStore.saveCustodianDefaultList (request)
        .finally(() => this.submitCuratedDisabled = false);
  }

  saveSdbaList () {
    if (this.submitSdbaDisabled) {
      return;
    }

    this.submitSdbaDisabled = true;

    const request: CustodianDrivewealthListRequest = {
      custodian: Number(this.custodian),
      instrumentListId: this.sdbaDefaultInstrumentListId,
      investmentOption: DrivewealthAccountManagementType.OpenBrokerage
    };
    this.instrumentListStore.saveCustodianDefaultList (request)
        .finally(() => this.submitSdbaDisabled = false);
  }

  saveManagedDefault () {
    if (this.submitManagedDisabled) {
      return;
    }

    if (this.managedAgreementListId === "0") {
      this.errors.add({field: "managed-agreement", msg: "Please select default agreement"});
      return;
    }

    this.submitManagedDisabled = true;

    const request: UpdateCustodianDefaultAgreementRequest = {
      custodian: this.custodian,
      accountType: DrivewealthAccountManagementType.RiaManaged,
      documentKey: this.managedAgreementListId
    };
    this.signingDocumentStore.saveCustodianDefaultAgreement(request)
        .finally(() => this.submitManagedDisabled = false);
  }

  saveAdvisoryDefault () {
    if (this.submitAdvisoryDisabled) {
      return;
    }

    if (this.advisoryAgreementListId === "0") {
      this.errors.add({field: "advisory-agreement", msg: "Please select default agreement"});
      return;
    }

    this.submitAdvisoryDisabled = true;

    const request: UpdateCustodianDefaultAgreementRequest = {
      custodian: this.custodian,
      accountType: DrivewealthAccountManagementType.Advisory,
      documentKey: this.advisoryAgreementListId
    };
    this.signingDocumentStore.saveCustodianDefaultAgreement(request)
        .finally(() => this.submitAdvisoryDisabled = false);
  }

  saveOpenBrokerageDefault () {
    if (this.submitOpenBrokerageDisabled) {
      return;
    }

    if (this.openBrokerageAgreementListId === "0") {
      this.errors.add({field: "open-brokerage-agreement", msg: "Please select default agreement"});
      return;
    }

    this.submitOpenBrokerageDisabled = true;

    const request: UpdateCustodianDefaultAgreementRequest = {
      custodian: this.custodian,
      accountType: DrivewealthAccountManagementType.OpenBrokerage,
      documentKey: this.openBrokerageAgreementListId
    };
    this.signingDocumentStore.saveCustodianDefaultAgreement(request)
        .finally(() => this.submitOpenBrokerageDisabled = false);
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityDrvWealthInstrLstEdit);
  }

  get defaultAgreementOptions () {
    const agreements = this.signingDocumentStore.documentsAdmin
        .filter(x => x.agreementCategory === AgreementCategory.Investment)
        .map(x => {
          return { value: x.documentKey, text: x.name };
        });
    agreements.unshift({ value: "0", text: "Select Default Agreement" });
    return agreements;
  }
}
